import * as yup from 'yup';

export const schemaChangePassword = yup.object().shape({
  SenhaAntiga: yup.string().required('Senha antiga é obrigatória')
    .min(6, 'Senha muito curta. Deve ter pelo menos 6 caracteres.'),
  SenhaNova: yup.string().required('Senha é obrigatória')
    .min(6, 'Senha muito curta. Deve ter pelo menos 6 caracteres.'),
  ConfirmacaoSenha: yup.string()
     .oneOf([yup.ref('SenhaNova'), null], 'Senhas devem combinar')
     .required('Confirmação de senha é obrigatória')
});